import React from 'react';


class AppExtLogo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      logoHeight: 0,
      minOffset: 25,
      paddingOffset: 0,
    }

     // Bind event listeners
    this.adjustHeight = ::this.adjustHeight;
  }

  componentWillMount() {
    window.addEventListener('resize', this.adjustHeight, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
  }

  componentDidMount() {
    setTimeout(() => {
      this.adjustHeight();
    }, 50);
  }

  adjustHeight() {
    let foundChild = document.getElementById('externalChildWrapper');
    if(foundChild) {
      let offset = (window.innerHeight - (this.state.logoHeight + foundChild.offsetHeight + this.state.minOffset)) / 2;
      this.setState({ paddingOffset: offset > 0 ? offset + 'px' : 0 });
    }
  }

  render() {
    return <div 
      className='AppExtLogo'
      style={{
        paddingTop: this.state.paddingOffset === 0 ? this.state.minOffset + 'px' : this.state.paddingOffset,
      }}>
      <div id='externalChildWrapper'>{this.props.children}</div>
    </div>;
  }
}

export default AppExtLogo;


// WEBPACK FOOTER //
// ./src/components/views/common/AppExtLogo.jsx